import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationMethionineDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const tcn2 = getGenePalette(geneColors.TCN2);
  const fut2 = getGenePalette(geneColors.FUT2);
  const mtrr = getGenePalette(geneColors.MTRR);
  const mtr = getGenePalette(geneColors.MTR);
  const ahcy = getGenePalette(geneColors.AHCY);
  const bhmt = getGenePalette(geneColors.BHMT);
  const pemt = getGenePalette(geneColors.PEMT);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211484)">
        <rect width={1024} height={900} transform="translate(0 142)" fill="white" />
        <g id="methionine-cycle-overview-diagram">
          <rect width={1024} height={900} transform="translate(0 142)" fill="white" />
          <path
            id="Ellipse 7"
            d="M698.5 493.849L694.377 486.897L690.418 493.943L698.5 493.849ZM653 474.277L652.803 474.949C666.768 479.039 680.116 484.573 692.675 491.379L693.008 490.763L693.342 490.148C680.697 483.296 667.258 477.723 653.197 473.606L653 474.277Z"
            fill="#1A1A1A"
          />
          <path
            id="Ellipse 7_2"
            d="M779.114 764.5C793.116 736.686 801 705.264 801 672C801 616.956 779.411 566.954 744.238 530"
            stroke="#1A1A1A"
            strokeWidth={1.4}
          />
          <path
            id="Ellipse 7_3"
            d="M758.371 797.5L750.853 800.47L757.184 805.495L758.371 797.5ZM664 866.16L671.971 867.501L669.147 859.928L664 866.16ZM754.453 802.435L753.911 801.992C731.739 829.064 702.785 850.368 669.645 863.308L669.9 863.96L670.155 864.612C703.522 851.583 732.672 830.135 754.994 802.879L754.453 802.435Z"
            fill="#1A1A1A"
          />
          <path
            id="Ellipse 7_4"
            d="M541.5 473.016L533.661 471.046L535.874 478.82L541.5 473.016ZM664 866.16L656.074 864.574L658.663 872.231L664 866.16ZM389 672H389.7C389.7 579.252 451.204 500.866 535.654 475.408L535.452 474.738L535.25 474.068C450.225 499.699 388.3 578.617 388.3 672H389ZM658.034 868.178L657.82 867.511C638.022 873.867 616.912 877.3 595 877.3V878V878.7C617.059 878.7 638.313 875.244 658.248 868.844L658.034 868.178ZM595 878V877.3C481.616 877.3 389.7 785.384 389.7 672H389H388.3C388.3 786.157 480.843 878.7 595 878.7V878Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 292"
            d="M677.538 668.109L678.147 668.454L678.837 667.236L678.228 666.891L677.883 667.5L677.538 668.109ZM677.883 572L669.8 571.992L673.834 578.996L677.883 572ZM677.883 667.5L678.228 666.891C652.651 652.414 639.007 637.028 637.79 621.709C636.576 606.438 647.696 590.799 672.791 575.741L672.431 575.14L672.071 574.54C646.876 589.658 635.113 605.703 636.394 621.82C637.671 637.889 651.898 653.596 677.538 668.109L677.883 667.5Z"
            fill="#282828"
          />
          <path
            id="Vector 293"
            d="M831.538 651.109L832.147 651.454L832.837 650.236L832.228 649.891L831.883 650.5L831.538 651.109ZM831.883 555L823.8 554.992L827.834 561.996L831.883 555ZM831.883 650.5L832.228 649.891C806.651 635.414 793.007 620.028 791.79 604.709C790.576 589.438 801.696 573.799 826.791 558.741L826.431 558.14L826.071 557.54C800.876 572.658 789.113 588.703 790.394 604.82C791.671 620.889 805.898 636.596 831.538 651.109L831.883 650.5Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8"
            d="M282.5 817.638L290.328 819.653L288.159 811.867L282.5 817.638ZM389 680.5H388.3C388.3 744.048 346.2 797.765 288.368 815.277L288.571 815.947L288.774 816.617C347.18 798.931 389.7 744.682 389.7 680.5H389ZM282.5 543.362L282.327 544.04C343.245 559.54 388.3 614.759 388.3 680.5H389H389.7C389.7 614.104 344.195 558.338 282.673 542.683L282.5 543.362Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8_2"
            d="M207.5 544.733L199.603 543.008L202.058 550.709L207.5 544.733ZM205 815.506L205.21 814.839C148.111 796.881 106.7 743.526 106.7 680.5H106H105.3C105.3 744.155 147.125 798.039 204.79 816.174L205 815.506ZM106 680.5H106.7C106.7 618.764 146.434 566.306 201.726 547.308L201.499 546.646L201.271 545.984C145.431 565.17 105.3 618.147 105.3 680.5H106Z"
            fill="#282828"
          />
          <g id="lines">
            <path
              id="Vector_4"
              d="M598.342 847.3L598.342 848L599.742 848L599.742 847.3L599.042 847.3L598.342 847.3ZM599.042 494L595 501L603.083 501L599.042 494ZM599.042 847.3L599.742 847.3L599.742 500.3L599.042 500.3L598.342 500.3L598.342 847.3L599.042 847.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_5"
              d="M714.341 711.3L714.341 712L715.741 712L715.741 711.3L715.041 711.3L714.341 711.3ZM715.041 684L711 691L719.082 691L715.041 684ZM715.041 711.3L715.741 711.3L715.741 690.3L715.041 690.3L714.341 690.3L714.341 711.3L715.041 711.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Cofactor_3">
            <g id="diamond_3">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={32.4609} y={637.086}>
                  Zn
                </tspan>
              </text>
              <g id="Vector_6">
                <mask id="path-32-inside-3_18291_211484" fill="white">
                  <path d="M39 608L64 620.121V645.879L39 658L14 645.879V620.121L39 608Z" />
                </mask>
                <path
                  d="M39 608L64 620.121V645.879L39 658L14 645.879V620.121L39 608Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-32-inside-3_18291_211484)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_4">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={831.947} y={905.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_7">
                <mask id="path-34-inside-4_18291_211484" fill="white">
                  <path d="M840 876L865 888.121V913.879L840 926L815 913.879V888.121L840 876Z" />
                </mask>
                <path
                  d="M840 876L865 888.121V913.879L840 926L815 913.879V888.121L840 876Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-34-inside-4_18291_211484)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_5">
            <g id="diamond_5">
              <text
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={921.047} y={605.086}>
                  Choline
                </tspan>
              </text>
              <g id="Vector_8">
                <mask id="path-36-inside-5_18291_211484" fill="white">
                  <path d="M942 576L967 588.121V613.879L942 626L917 613.879V588.121L942 576Z" />
                </mask>
                <path
                  d="M942 576L967 588.121V613.879L942 626L917 613.879V588.121L942 576Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-36-inside-5_18291_211484)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_6">
            <g id="diamond_6">
              <text
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={436.816} y={645.767}>
                  SAMe
                </tspan>
              </text>
              <g id="Vector_9">
                <mask id="path-38-inside-6_18291_211484" fill="white">
                  <path d="M455 616L480 628.121V653.879L455 666L430 653.879V628.121L455 616Z" />
                </mask>
                <path
                  d="M455 616L480 628.121V653.879L455 666L430 653.879V628.121L455 616Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-38-inside-6_18291_211484)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_7">
            <g id="diamond_7">
              <text
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={532.371} y={580.767}>
                  Zn
                </tspan>
              </text>
              <g id="Vector_10">
                <mask id="path-40-inside-7_18291_211484" fill="white">
                  <path d="M540 551L565 563.121V588.879L540 601L515 588.879V563.121L540 551Z" />
                </mask>
                <path
                  d="M540 551L565 563.121V588.879L540 601L515 588.879V563.121L540 551Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-40-inside-7_18291_211484)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles">
            <rect width={46} height={36} transform="translate(748 753)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={748.137} y={779.196}>
                SAH
              </tspan>
            </text>
          </g>
          <path
            id="Vector 426"
            d="M821.5 725.42L819.681 717.545L813.77 723.058L821.5 725.42ZM801 682L800.301 682.037C800.833 692.118 805.201 707.771 816.668 721.265L817.201 720.811L817.734 720.358C806.488 707.123 802.216 691.773 801.699 681.963L801 682Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 426_2"
            d="M868.997 746.285L868.922 746.981L868.997 746.285ZM854.894 789.141L854.204 789.263L854.894 789.141ZM880.078 803.095L872.574 800.091L873.724 808.091L880.078 803.095ZM858.999 744.713L858.855 745.398C862.049 746.07 865.402 746.603 868.922 746.981L868.997 746.285L869.071 745.589C865.597 745.216 862.29 744.69 859.144 744.028L858.999 744.713ZM868.997 746.285L868.922 746.981C877.03 747.852 882.799 748.859 886.707 749.985C888.662 750.548 890.125 751.133 891.174 751.731C892.23 752.332 892.812 752.914 893.087 753.444C893.347 753.944 893.369 754.464 893.15 755.06C892.921 755.683 892.43 756.384 891.66 757.163C890.121 758.722 887.645 760.42 884.625 762.256C878.653 765.888 870.596 770.024 864.343 774.445C861.204 776.664 858.453 778.998 856.595 781.439C854.734 783.884 853.717 786.509 854.204 789.263L854.894 789.141L855.583 789.02C855.189 786.791 855.981 784.557 857.709 782.287C859.44 780.013 862.056 777.776 865.151 775.588C871.364 771.196 879.236 767.172 885.352 763.453C888.376 761.614 890.985 759.839 892.656 758.147C893.492 757.301 894.138 756.432 894.464 755.543C894.8 754.627 894.794 753.692 894.33 752.799C893.881 751.935 893.043 751.184 891.867 750.514C890.686 749.841 889.107 749.219 887.095 748.639C883.07 747.48 877.207 746.462 869.071 745.589L868.997 746.285ZM854.894 789.141L854.204 789.263C855.311 795.518 858.278 799.456 861.989 801.786C865.674 804.101 870.025 804.789 873.86 804.691L873.842 803.991L873.825 803.292C870.16 803.385 866.11 802.722 862.733 800.601C859.382 798.495 856.625 794.913 855.583 789.02L854.894 789.141Z"
            fill="#1A1A1A"
          />
          <g id="Report titles_2">
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={687.342} y={673.12}>
                Betaine
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={684.334} y={728.12}>
                Choline
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={42} height={28} transform="translate(680 552)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={680.223} y={572.12}>
                DMG
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={137} height={20} transform="translate(835 544)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={835.455} y={558.08}>
                Phosphatidylcholine (PC)
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={171} height={20} transform="translate(835 641)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={835.299} y={655.08}>
                Phosphatidylethanolamine (PE)
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={113} height={20} transform="translate(827 720)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={827.18} y={734.08}>
                Methyl Group (-CH3)
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={70} height={28} transform="translate(129 272)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={129.258} y={291.44}>
                Transport
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={80} height={28} transform="translate(277 272)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={277.102} y={291.44}>
                Absorption
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={100} height={68} transform="translate(892 770)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={892} y={784.08}>
                For methylation of{" "}
              </tspan>
              <tspan x={892} y={800.08}>
                DNA, RNA,{" "}
              </tspan>
              <tspan x={892} y={816.08}>
                proteins, lipids{" "}
              </tspan>
              <tspan x={892} y={832.08}>
                and metabolites
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={109} height={28} transform="translate(547 452)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={555.067} y={472.147}>
                Methionine
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <rect width={52} height={36} transform="translate(214 347)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={222.023} y={373.196}>
                B12
              </tspan>
            </text>
          </g>
          <path
            id="Vector 429"
            d="M239.001 449L238.605 448.423L239.001 449ZM119.001 500L119.661 499.767L119.001 500ZM165.001 547L160.067 540.598L156.989 548.072L165.001 547ZM239.001 388L238.402 388.362C249.842 407.263 251.625 421.062 249.722 430.705C247.817 440.351 242.199 445.956 238.605 448.423L239.001 449L239.397 449.577C243.223 446.951 249.105 441.057 251.095 430.976C253.086 420.891 251.159 406.737 239.599 387.638L239.001 388ZM239.001 449L238.605 448.423C213.276 465.805 179.922 468.456 154.443 471.795C148.088 472.628 142.219 473.506 137.106 474.672C131.999 475.837 127.601 477.3 124.21 479.325C120.807 481.356 118.384 483.976 117.306 487.449C116.234 490.908 116.531 495.105 118.341 500.233L119.001 500L119.661 499.767C117.909 494.804 117.691 490.934 118.644 487.863C119.592 484.806 121.733 482.434 124.928 480.527C128.134 478.612 132.367 477.189 137.418 476.037C142.462 474.886 148.276 474.016 154.625 473.183C179.956 469.863 213.725 467.195 239.397 449.577L239.001 449ZM119.001 500L118.341 500.233C128.422 528.798 147.392 540.121 158.89 545.241L159.175 544.601L159.459 543.962C148.178 538.938 129.573 527.85 119.661 499.767L119.001 500Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 427"
            d="M108 302H107.3V302.7H108V302ZM230 302H230.7V301.3H230V302ZM230 347L234.041 340H225.959L230 347ZM108 266H107.3V302H108H108.7V266H108ZM108 302V302.7H230V302V301.3H108V302ZM230 302H229.3V340.7H230H230.7V302H230Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 428"
            d="M375 302H375.7V302.7H375V302ZM253 302H252.3V301.3H253V302ZM253 347L248.959 340H257.041L253 347ZM375 266H375.7V302H375H374.3V266H375ZM375 302V302.7H253V302V301.3H375V302ZM253 302H253.7V340.7H253H252.3V302H253Z"
            fill="#1A1A1A"
          />
          <g id="Report titles_13">
            <rect width={134} height={28} transform="translate(530 852)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={538.254} y={872.147}>
                Homocysteine
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={64} height={28} transform="translate(699 497)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={707.27} y={517.147}>
                SAMe
              </tspan>
            </text>
          </g>
          <g id="gene-TCN2" {...geneGroupProps("TCN2", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M64 206C64 203.791 65.7909 202 68 202H160C162.209 202 164 203.791 164 206V242C164 244.209 162.209 246 160 246H68C65.7909 246 64 244.209 64 242V206Z"
                fill={tcn2.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={84.5977} y={232.16}>
                  TCN2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="tcn2"
              groupId="gene-snps"
              genePalette={tcn2}
              startX={72}
              startY={248}
              snpCount={getGeneSnpCount("TCN2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FUT2" {...geneGroupProps("FUT2", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M325 210C325 207.791 326.791 206 329 206H421C423.209 206 425 207.791 425 210V246C425 248.209 423.209 250 421 250H329C326.791 250 325 248.209 325 246V210Z"
                fill={fut2.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={348.48} y={236.16}>
                  FUT2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fut2"
              groupId="gene-snps_2"
              genePalette={fut2}
              startX={333}
              startY={252}
              snpCount={getGeneSnpCount("FUT2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTRR" {...geneGroupProps("MTRR", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M339 662C339 659.791 340.791 658 343 658H435C437.209 658 439 659.791 439 662V698C439 700.209 437.209 702 435 702H343C340.791 702 339 700.209 339 698V662Z"
                fill={mtrr.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={358.273} y={688.16}>
                  MTRR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mtrr"
              groupId="gene-snps_3"
              genePalette={mtrr}
              startX={347}
              startY={704}
              snpCount={getGeneSnpCount("MTRR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTR" {...geneGroupProps("MTR", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M52 657.5C52 655.291 53.7909 653.5 56 653.5H148C150.209 653.5 152 655.291 152 657.5V693.5C152 695.709 150.209 697.5 148 697.5H56C53.7909 697.5 52 695.709 52 693.5V657.5Z"
                fill={mtr.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={78.5977} y={683.66}>
                  MTR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mtr"
              groupId="gene-snps_4"
              genePalette={mtr}
              startX={60}
              startY={699.5}
              snpCount={getGeneSnpCount("MTR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AHCY" {...geneGroupProps("AHCY", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M715 842C715 839.791 716.791 838 719 838H811C813.209 838 815 839.791 815 842V878C815 880.209 813.209 882 811 882H719C716.791 882 715 880.209 715 878V842Z"
                fill={ahcy.lozengeFill}
              />
              <text
                id="gene-label_9"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={733.383} y={868.16}>
                  AHCY
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ahcy"
              groupId="gene-snps_5"
              genePalette={ahcy}
              startX={723}
              startY={884}
              snpCount={getGeneSnpCount("AHCY", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-BHMT" {...geneGroupProps("BHMT", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M553 599C553 596.791 554.791 595 557 595H649C651.209 595 653 596.791 653 599V635C653 637.209 651.209 639 649 639H557C554.791 639 553 637.209 553 635V599Z"
                fill={bhmt.lozengeFill}
              />
              <text
                id="gene-label_10"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={571.324} y={625.16}>
                  BHMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="bhmt"
              groupId="gene-snps_6"
              genePalette={bhmt}
              startX={561}
              startY={641}
              snpCount={getGeneSnpCount("BHMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PEMT" {...geneGroupProps("PEMT", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M811 580C811 577.791 812.791 576 815 576H907C909.209 576 911 577.791 911 580V616C911 618.209 909.209 620 907 620H815C812.791 620 811 618.209 811 616V580Z"
                fill={pemt.lozengeFill}
              />
              <text
                id="gene-label_11"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={831.48} y={606.16}>
                  PEMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pemt"
              groupId="gene-snps_7"
              genePalette={pemt}
              startX={819}
              startY={622}
              snpCount={getGeneSnpCount("PEMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="report-recycle-symbol_2">
            <g id="Vector_11">
              <mask id="path-102-inside-8_18291_211484" fill="white">
                <path d="M230.503 712.996C230.503 715.067 228.824 716.746 226.754 716.746H204.258C195.602 716.741 190.196 707.368 194.524 699.87L210.594 672.094L204.009 673.852C201.213 674.599 198.657 672.038 199.409 669.243C199.757 667.945 200.771 666.932 202.069 666.586L217.427 662.474C219.428 661.938 221.485 663.126 222.02 665.128L226.14 680.49C226.687 682.502 225.489 684.574 223.473 685.103C223.155 685.186 222.827 685.228 222.498 685.23C220.802 685.228 219.319 684.088 218.88 682.45L217.099 675.816L201.029 703.62C199.59 706.113 201.38 709.232 204.258 709.246H226.754C228.824 709.246 230.503 710.925 230.503 712.996ZM296.458 699.87L285.613 681.118C284.064 678.682 280.46 678.836 279.125 681.395C278.557 682.483 278.558 683.781 279.126 684.869L289.971 703.62C291.41 706.113 289.62 709.232 286.742 709.246H254.55L259.396 704.398C261.438 702.358 260.505 698.871 257.718 698.122C256.424 697.775 255.043 698.144 254.095 699.092L242.847 710.343C241.381 711.808 241.381 714.184 242.847 715.649L254.095 726.9C256.137 728.941 259.622 728.005 260.368 725.216C260.714 723.922 260.343 722.541 259.396 721.594L254.55 716.746H286.742C295.398 716.741 300.804 707.368 296.476 699.87H296.458ZM245.5 630.489C246.842 630.475 248.085 631.194 248.743 632.364L264.814 660.14L258.215 658.368C255.405 657.708 252.935 660.338 253.769 663.102C254.132 664.307 255.075 665.249 256.279 665.611L271.642 669.731C271.959 669.815 272.285 669.857 272.612 669.858C274.308 669.856 275.791 668.716 276.23 667.078L280.35 651.706C281.166 648.937 278.679 646.323 275.873 647C274.506 647.331 273.439 648.398 273.109 649.766L271.328 656.408L255.234 628.614C250.902 621.129 240.098 621.129 235.766 628.614L224.912 647.365C223.534 649.902 225.419 652.979 228.304 652.904C229.573 652.871 230.739 652.198 231.403 651.116L242.257 632.364C242.915 631.194 244.158 630.475 245.5 630.489Z" />
              </mask>
              <path
                d="M230.503 712.996C230.503 715.067 228.824 716.746 226.754 716.746H204.258C195.602 716.741 190.196 707.368 194.524 699.87L210.594 672.094L204.009 673.852C201.213 674.599 198.657 672.038 199.409 669.243C199.757 667.945 200.771 666.932 202.069 666.586L217.427 662.474C219.428 661.938 221.485 663.126 222.02 665.128L226.14 680.49C226.687 682.502 225.489 684.574 223.473 685.103C223.155 685.186 222.827 685.228 222.498 685.23C220.802 685.228 219.319 684.088 218.88 682.45L217.099 675.816L201.029 703.62C199.59 706.113 201.38 709.232 204.258 709.246H226.754C228.824 709.246 230.503 710.925 230.503 712.996ZM296.458 699.87L285.613 681.118C284.064 678.682 280.46 678.836 279.125 681.395C278.557 682.483 278.558 683.781 279.126 684.869L289.971 703.62C291.41 706.113 289.62 709.232 286.742 709.246H254.55L259.396 704.398C261.438 702.358 260.505 698.871 257.718 698.122C256.424 697.775 255.043 698.144 254.095 699.092L242.847 710.343C241.381 711.808 241.381 714.184 242.847 715.649L254.095 726.9C256.137 728.941 259.622 728.005 260.368 725.216C260.714 723.922 260.343 722.541 259.396 721.594L254.55 716.746H286.742C295.398 716.741 300.804 707.368 296.476 699.87H296.458ZM245.5 630.489C246.842 630.475 248.085 631.194 248.743 632.364L264.814 660.14L258.215 658.368C255.405 657.708 252.935 660.338 253.769 663.102C254.132 664.307 255.075 665.249 256.279 665.611L271.642 669.731C271.959 669.815 272.285 669.857 272.612 669.858C274.308 669.856 275.791 668.716 276.23 667.078L280.35 651.706C281.166 648.937 278.679 646.323 275.873 647C274.506 647.331 273.439 648.398 273.109 649.766L271.328 656.408L255.234 628.614C250.902 621.129 240.098 621.129 235.766 628.614L224.912 647.365C223.534 649.902 225.419 652.979 228.304 652.904C229.573 652.871 230.739 652.198 231.403 651.116L242.257 632.364C242.915 631.194 244.158 630.475 245.5 630.489Z"
                stroke="#282828"
                strokeWidth={2}
                mask="url(#path-102-inside-8_18291_211484)"
              />
            </g>
          </g>
          <g id="Vitamin-Mineral_2">
            <text
              id="Title"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={218.363} y={504.767}>
                Oxidised
              </tspan>
            </text>
            <g id="Frame 471">
              <g id="diamond_8">
                <text
                  id="label_6"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={235.289} y={548.448}>
                    B12
                  </tspan>
                </text>
                <path
                  id="Vector_12"
                  d="M246.378 512.938L276.378 542.938L246.378 572.938L216.378 542.938L246.378 512.938Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_3">
            <g id="Frame 471_2">
              <g id="diamond_9">
                <text
                  id="label_7"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={234.289} y={822.448}>
                    B12
                  </tspan>
                </text>
                <path
                  id="Vector_13"
                  d="M245.378 786.938L275.378 816.938L245.378 846.938L215.378 816.938L245.378 786.938Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
              </g>
            </g>
            <text
              id="Title_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={216.666} y={864.767}>
                Reduced
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationMethionineDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={900}
    viewBox="0 142 1024 900"
    fill="none"
    {...props}
  >
    <MethylationMethionineDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211484">
        <rect width={1024} height={1042} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211484">
        <rect width={1024} height={900} fill="white" transform="translate(0 142)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationMethionineDiagram;
